import { render, staticRenderFns } from "./UserWindowView.vue?vue&type=template&id=bd182880&scoped=true&"
import script from "./UserWindowView.vue?vue&type=script&lang=js&"
export * from "./UserWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd182880",
  null
  
)

export default component.exports